/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_AppConfiguration_AppConfigurationDto } from '../models/Routemize_DTOs_AppConfiguration_AppConfigurationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AppConfigurationService {
    /**
     * @returns Routemize_DTOs_AppConfiguration_AppConfigurationDto OK
     * @throws ApiError
     */
    public static getApiAppAppConfiguration(): CancelablePromise<Routemize_DTOs_AppConfiguration_AppConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/appConfiguration',
        });
    }
}
